import { SVCurrencyInput } from '@/components/core';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Grid, Stack, Typography } from '@mui/material';

export const CheckIssuingControls = () => {
  const {
    PROGRAM_LEVEL_MAX_DAILY_CHECK_ISSUING_AMOUNT,
    BANK_ACCOUNT_LEVEL_MAX_DAILY_CHECK_ISSUING_AMOUNT,
    BANK_ACCOUNT_LEVEL_MAX_MONTHLY_CHECK_ISSUING_AMOUNT,
    TRANSACTION_LEVEL_MAX_DAILY_PER_CHECK_AMOUNT,
  } = PROGRAM_SETTINGS.CHECK_ISSUING_CONTROLS;

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Program Level Daily Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkIssuanceProgramLimitPerRollingDay"
            label={PROGRAM_LEVEL_MAX_DAILY_CHECK_ISSUING_AMOUNT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (24 Hour Rolling Aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Bank Account Level Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkIssuanceAccountLimitPerCalendarDay"
            label={BANK_ACCOUNT_LEVEL_MAX_DAILY_CHECK_ISSUING_AMOUNT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar Day EST Aggregate)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ mt: { xs: 0, md: 6 } }}>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkIssuanceAccountLimitPerCalendarMonth"
            label={BANK_ACCOUNT_LEVEL_MAX_MONTHLY_CHECK_ISSUING_AMOUNT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Calendar Month)
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} mb={2}>
        <Typography component="h6" fontWeight="bold" mb={2}>
          Transaction Level Daily Limits
        </Typography>
        <Stack spacing={1} sx={{ width: '100%' }}>
          <SVCurrencyInput
            name="checkIssuanceLimitPerTransaction"
            label={TRANSACTION_LEVEL_MAX_DAILY_PER_CHECK_AMOUNT.LABEL}
          />
          <Typography variant="body2" color="text.secondary" mt={0}>
            (Per Transaction)
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
